import { IsNull } from "../checks/IsNull"

/**
 * Generates a sequence of numbers.
 * With one argument: generates 0 to n1-1.
 * With two arguments: generates n1 to n2 (inclusive).
 * Supports custom step size and descending ranges.
 *
 * @param n1 - Start value (or end value if n2 is undefined)
 * @param n2 - Optional end value (inclusive)
 * @param step - Step size (default: 1)
 * @returns Generator yielding numbers in the range
 *
 * @example
 * ```ts
 * import { Range } from "@pdfking/tfunc"
 *
 * [...Range(5)] // [0, 1, 2, 3, 4]
 * [...Range(1, 5)] // [1, 2, 3, 4, 5]
 * [...Range(0, 10, 2)] // [0, 2, 4, 6, 8, 10]
 * [...Range(5, 1, -1)] // [5, 4, 3, 2, 1]
 * ```
 */
export const Range = function* (n1: number, n2?: number, step = 1) {
  if (IsNull(n2)) {
    // If only one parameter is provided, generate range from 0 to n1-1
    for (let i = 0; i < n1; i += step) {
      yield i
    }
  } else {
    // With start and end, generate inclusive range from n1 to n2
    if (step > 0) {
      for (let i = n1; i <= n2; i += step) {
        yield i
      }
    } else {
      for (let i = n1; i >= n2; i += step) {
        yield i
      }
    }
  }
}
